import {AppContext} from "../../../lib/AppContext";
import React, {useContext, useRef, useState} from "react";

import {Card, CardContent, Chip} from "@mui/material";
import MDButton from "../../../components/MDButton";
import {CONSTANTS} from "../../common/constants";
import Divider from "@mui/material/Divider";
import {Col, Row} from "react-bootstrap";
import AddGuestsModal from "../modal/AddGuestsModal";
import Icon from "@mui/material/Icon";
import QRCode from "react-qr-code";
import {getGuestWaiver, previewGuestWaiver, saveGuestCheckIn, saveGuestCustomer} from "../../common/api/WebApi";
import Menu from "@mui/material/Menu";
import NotificationItem from "../../Items/NotificationItem";
import Preview from "../../common/modal/preview";
import ManageClientModal from "../../client/ManageClientModal";
import {Link, useNavigate} from "react-router-dom";
import WaiverQrCode from "../../client/WaiverQrCode";
import QrCodeIcon from "@mui/icons-material/QrCode";
import {removeInventoryEventGuest} from "../../common/api/InventoryApi";
import Grid from "@mui/material/Grid";

export default function EventGuests({inventory, callback}) {
  const [context, setContext] = useContext(AppContext);
  const [showGuestsForm, setShowGuestsForm] = useState(false);
  const [createCustomer, setCreateCustomer] = useState(false);
  const navigate = useNavigate();

  const [saving, setSaving] = useState(false);

  const startAddGuests = () => {
    setShowGuestsForm(true);
  }

  const [showQrCode, setShowQrCode] = useState(false);
  const [waiverPreview, setWaiverPreview] = useState();
  const [showPreview, setShowPreview] = useState(false);
  const myRefs = useRef([]);
  const [renderIndex, setRenderIndex] = useState(1);

  const refHandler = (index) => {
    myRefs.current[index].visible = !!!myRefs.current[index].visible;
    setRenderIndex(renderIndex + 1);
  };
  const viewWaiver = async (item) => {
    previewGuestWaiver(item.waiverGuid).then((result) => {
      setWaiverPreview(result);
      setShowPreview(true);
    });
  }

  const [customer, setCustomer] = useState(null);
  const [guest, setGuest] = useState();

  const removeGuest = (guest) => {
    setSaving(true);
    removeInventoryEventGuest(guest).then((result) => {
      setSaving(false);
      callback('reload')
    });
  }

  const startCreateCustomer = (_guest) => {
    setCreateCustomer(true);
    setGuest({..._guest});
    setCustomer({
      firstName: _guest?.firstName,
      lastName: _guest?.lastName,
      email: _guest?.email,
      primaryPhone: _guest?.phone,
    });
  }

  const downloadWaiver = async (item) => {
    getGuestWaiver(item.waiverGuid).then((result) => {
      let blob = new Blob([result], {type: 'application/pdf'});
      if (navigator.msSaveBlob) { // IE 10+
        navigator.msSaveBlob(blob, item.waiverName + '.pdf');
      } else {
        let link = document.createElement("a");
        if (link.download !== undefined) { // feature detection
          // Browsers that support HTML5 download attribute
          let url = URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.setAttribute("download", 'Event-Waiver-' + item.waiverGuid + '.pdf');
          link.style.visibility = 'hidden';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }
    });
  }

  const handleSaveCustomer = async (customer) => {

    setSaving(true);
    const guestMember = {
      user: customer,
      guest: guest
    }

    let result = await saveGuestCustomer(guestMember);

    if (result.error) {
      setContext({...context, error: {message: result.message}});
    } else {
      setSaving(false);
      setCustomer(null);
      setCreateCustomer(false);
      callback('reload')
    }
  }

  const handleGuestCheckIn = async (guest) => {
    guest.checkingIn = true;
    let result = await saveGuestCheckIn(guest);

    if (result.error) {
      setContext({...context, error: {message: result.message}});
    } else {
      setSaving(false);
      setCustomer(null);
      setCreateCustomer(false);
      callback('reload')
    }
  }

  const GuestsSnapshot = () => {
    let total = inventory?.guests?.length;
    let checkedIn = inventory?.guests?.filter((g) => g.checkedIn)?.length;
    let checkedInChildren = inventory?.guests?.filter((g) => g.checkedIn && g.child)?.length;
    let checkedInAdults = inventory?.guests?.filter((g) => g.checkedIn && !g.child)?.length;

    return (
      <div>
        {total > 0 &&
          <span>
          <Chip
            label={<>
              Guests <b>{total}</b>
            </>}
            variant="outlined"
          />
            &nbsp;
            <Chip
              label={<>
                Checked In <b>{checkedIn}</b>
              </>}
              variant="outlined"
            />
            &nbsp;
            <Chip
              label={<>
                Checked In Adults <b>{checkedInAdults}</b>
              </>}
              variant="outlined"
            />
            &nbsp;
            <Chip
              label={<>
                Checked In Children <b>{checkedInChildren}</b>
              </>}
              variant="outlined"
            />
        </span>
        }
      </div>
    )
  }

  return (
    <>
      <Card>
        <CardContent>
          <MDButton
            color="secondary"
            size="small"
            className={'pull-right'}
            disabled={inventory?.status?.id === CONSTANTS.STATUS.INACTIVE}
            onClick={(e) => {
              e.preventDefault();
              startAddGuests();
            }}>
            <span className={'fa fa-user-plus'}></span>&nbsp;Add
          </MDButton>

          {inventory?.waiverUrl && inventory?.eventType?.guestWaiverGk && <MDButton
            color="secondary"
            size="small"
            className={'pull-right mx-2'}
            disabled={inventory?.status?.id === CONSTANTS.STATUS.INACTIVE}
            onClick={(e) => {
              setShowQrCode(true);
            }}>
            <QrCodeIcon/>&nbsp;Waiver
          </MDButton>
          }

          <h5>
            Event Guests
          </h5>

          <GuestsSnapshot/>

          <Divider/>
          <Row>
            <Col sm={12}>
              <ul className={'list-group'}>
                {inventory?.guests && inventory?.guests?.length === 0 && <li className={'list-group-item'}>
                  <center>No additional guests for this event</center>
                </li>}
                {inventory?.guests?.length > 0 && inventory?.guests.sort((a, b) => a.id > b.id ? 1 : -1).map((guest, index) => {
                  return (<li key={index} className={'list-group-item'}>
                      <Grid container spacing={1}>
                        <Grid item xs={1}>
                          <MDButton
                            variant={guest?.checkedIn ? 'contained' : 'outlined'}
                            color="secondary"
                            size="small"
                            circular
                            iconOnly
                            title={guest?.checkedIn ? 'Undo Check In' : 'Check In'}
                            alt={guest?.checkedIn ? 'Undo Check In' : 'Check In'}
                            onClick={() => {
                              handleGuestCheckIn(guest)
                            }}
                          >
                            {guest?.checkingIn && <span className={'fa fa-circle-o-notch fa-spin'}></span>}
                            {!guest?.checkingIn && <>
                              {guest?.checkedIn && <Icon>cake</Icon>}
                              {!guest?.checkedIn && <Icon>person_add</Icon>}
                            </>}
                          </MDButton>

                        </Grid>
                        <Grid item xs={10}>
                          <span>
                          {guest?.memberGuid?.length > 0 && <>
                            <Link to={`/client/${guest.memberGuid}`}>{guest?.firstName}&nbsp;{guest?.lastName}
                              {guest?.child && ' (child)'}</Link>
                          </>}
                            {!(guest?.memberGuid?.length > 0) && <>
                              {guest?.firstName}&nbsp;{guest?.lastName}{guest?.child && ' (child)'}
                            </>}
                          </span>
                          {guest?.hasWaiver && <>
                            <br/>
                            <Chip
                              color={"success"}
                              variant="outlined"
                              label={<>
                                Waiver {<Icon>checkmark</Icon>}
                              </>}/>
                          </>
                          }
                        </Grid>
                        <Grid item alignItems={'flex-end'} xs={1}>
                          <div className={'pull-right px-2'}
                               onClick={(e) => {
                                 refHandler('downloadWaiver' + index)
                               }}
                               ref={el => (myRefs.current['downloadWaiver' + index] = el)}>

                            <MDButton
                              variant="outlined"
                              color="secondary"
                              size="small"
                              circular
                              iconOnly
                            >
                              <Icon>more_horiz</Icon>
                            </MDButton>

                            {renderIndex && myRefs.current['downloadWaiver' + index]?.visible &&
                              <Menu open={true} anchorReference={null}
                                    anchorEl={myRefs.current['downloadWaiver' + index]}
                                    anchorOrigin={{
                                      vertical: "bottom",
                                      horizontal: "left",
                                    }}>
                                {guest?.hasWaiver &&
                                  <NotificationItem onClick={(e) => {
                                    viewWaiver(guest)
                                  }} icon={<Icon>launch</Icon>} title="View Waiver"/>
                                }
                                {guest?.hasWaiver &&
                                  <NotificationItem onClick={(e) => {
                                    downloadWaiver(guest)
                                  }} icon={<Icon>download</Icon>} title="Download Waiver"/>
                                }
                                {!(guest?.memberGuid?.length > 0) &&
                                  <NotificationItem
                                    disabled={guest?.child}
                                    onClick={(e) => {
                                      startCreateCustomer(guest)
                                    }} icon={<Icon>person_add</Icon>} title="Convert to Customer"/>
                                }
                                {(guest?.memberGuid?.length > 0) &&
                                  <NotificationItem onClick={(e) => {
                                    navigate('/client/' + guest.memberGuid)
                                  }} icon={<Icon>person</Icon>} title="View Customer"/>
                                }

                                <NotificationItem onClick={(e) => {
                                  handleGuestCheckIn(guest)
                                }} icon={
                                  <>
                                    {guest?.checkedIn && <Icon>restore</Icon>}
                                    {!guest?.checkedIn && <Icon>cake</Icon>}
                                  </>} title={guest?.checkedIn ? 'Undo Check In' : 'Check In'}/>
                                <Divider/>
                                <NotificationItem onClick={(e) => {
                                  removeGuest(guest)
                                }} icon={<Icon>delete</Icon>} title="Remove"/>

                              </Menu>
                            }
                          </div>
                        </Grid>
                      </Grid>

                    </li>
                  )
                })}
              </ul>
            </Col>
          </Row>

        </CardContent>
      </Card>

      <div style={{
        display: 'none'
      }}>
        <div id="event-qr-code">
          <div style={{
            width: '40%',
            margin: '0 auto'
          }}>
            <QRCode
              size={256}
              style={{height: "auto", maxWidth: "100%", width: "100%"}}
              value={inventory?.waiverUrl}
              viewBox={'0 0 256 256'}/>
          </div>
          <center>
            <p>{inventory?.name} Event waiver</p>
            <p>{inventory?.waiverUrl}</p>
          </center>
        </div>
      </div>

      {createCustomer && <ManageClientModal
        customer={customer}
        show={createCustomer}
        saving={saving}
        handleSaveCustomer={(member) => {
          handleSaveCustomer(member)
        }}
        handleClose={() => {
          setCustomer(null);
          setCreateCustomer(false);
          callback('reload')
        }}/>
      }
      {showPreview &&
        <Preview previewContent={waiverPreview?.waiverBody}
                 previewTitle={waiverPreview?.waiverName}
                 showPreview={showPreview}
                 handleClose={() => {
                   setShowPreview(false);
                 }}/>
      }

      {showQrCode && <WaiverQrCode inventory={inventory} show={showQrCode} handleClose={() => {
        setShowQrCode(false)
      }}/>}

      {showGuestsForm &&
        <AddGuestsModal
          inventory={inventory} handleClose={() => {
          setShowGuestsForm(false)
        }}
          handleSave={() => {
            setShowGuestsForm(false)
            callback('reload')
          }}
          show={showGuestsForm}
        />
      }
    </>
  )
}